module.exports = __webpack_public_path__ + "static/chest--unlocked-cc10147771d3704616128611503f5077.png";